import request from '@/utils/request'

const networkmodelApi={
    getAll:'/train/rest/network_model/get_all',
}
export function getAll(){
    return request({
        url:networkmodelApi.getAll,
        method: 'get'
    })
}